import styled from "styled-components";
import ImageButton from "./ImageButton";
import { colors } from "constants/colors";
import { useErrorStore } from "stores/errorStore";
import { StyledText } from "styles/Text";

// 이벤트/콜백에서는 훅 대신 getState() 사용 (Invalid hook call 방지)
export const goBack = () => {
  if (window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(
      JSON.stringify({ type: "close", link: "" }),
    );
  } else {
    useErrorStore.getState().setError({ errorMessage: "모바일이 아닙니다" });
  }
};

// 레프트 헤더 (취소 버튼)
const HeaderLeftCancelButton = (props: { goBack?: () => void }) => (
  <StyledHeaderLeftBox>
    <ImageButton
      width={36}
      height={36}
      source={require("assets/images/ic_close_normal_outlined_black_m.png")}
      onClick={props.goBack ?? goBack}
    />
  </StyledHeaderLeftBox>
);

// 헤더 타이틀 컴포넌트
export const HeaderTitleComponent = (props: {
  children: React.ReactElement;
}): React.ReactElement => (
  <StyledHeaderTitleContainerBox>
    <StyledHeaderTitleLeftLine />
    <StyledHeaderTitleBox>{props.children}</StyledHeaderTitleBox>
  </StyledHeaderTitleContainerBox>
);

// 헤더 캔슬버튼 타이틀
export const HeaderCancelButtonComponent = (props: {
  title?: string;
  goBack?: () => void;
}): React.ReactElement => (
  <StyledHeaderFixedContainer>
    <h1 className="hide">열달후에</h1>
    <HeaderLeftCancelButton goBack={props.goBack ?? goBack} />
    {props.title && (
      <>
        <StyledHeaderTitleLeftLine />
        <StyledHeaderTitleBox>
          <StyledText.Headline15 as="h2">{props.title}</StyledText.Headline15>
        </StyledHeaderTitleBox>
      </>
    )}
  </StyledHeaderFixedContainer>
);

// 헤더 메인 타이틀 컴포넌트(bottomTab Page)
export const HeaderMainTitleComponent = (props: {
  children: React.ReactElement;
}): React.ReactElement => (
  <StyledHeaderMainTitleContainerBox>
    {props.children}
  </StyledHeaderMainTitleContainerBox>
);

const StyledHeaderLeftBox = styled.div`
  height: 56px;
  display: flex;
  align-items: center;
  padding-left: 16px;
`;

const StyledHeaderTitleContainerBox = styled.div`
  display: flex;
  align-items: center;
`;

const StyledHeaderTitleLeftLine = styled.div`
  width: 1px;
  height: 22.5px;
  background-color: ${colors.lightGray2};
`;

const StyledHeaderTitleBox = styled.div`
  margin-left: 8px;
  flex-direction: row;
`;

const StyledHeaderMainTitleContainerBox = styled.div`
  display: flex;
  padding-left: 20px;
  height: 56px;
  align-items: center;
`;

const StyledHeaderFixedContainer = styled.header`
  z-index: 1;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  height: 56px;
  align-items: center;
  background-color: ${colors.white};
`;
